import React from "react";
import { MdArrowForwardIos } from "react-icons/md";

const AssessmentCodeCard = ({ title, description, count, imageUrl, onViewAll }) => {
  return (
    <div className="bg-white rounded-2xl border border-gray-300 shadow-sm hover:shadow-md transition-shadow duration-300 overflow-hidden flex flex-col justify-between">
      <div className="">
        <div className="h-64 w-full overflow-hidden bg-white">
          <img src={imageUrl} alt={title} className="w-full h-full object-cover" />
        </div>
        <div className="p-6">
          <h3 className="text-xl font-medium text-gray-900 mb-3">{title}</h3>
          <p className="text-gray-500 text-sm leading-relaxed mb-6">{description}</p>
          <div className="bg-indigo-50 border-2 border-gray-300 rounded-xl p-4 flex items-center justify-between mb-6">
            <div>
              <p className="text-sm text-gray-900 capitalize mb-1">Available Codes</p>
              <p className="text-3xl font-semibold text-gray-900">{count}</p>
            </div>
            <div className="w-12 h-12 rounded-lg bg-indigo-100 text-indigo-600 flex items-center justify-center">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 001 1.5 2 2 0 010 3.5 2 2 0 00-2 2v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 00-2-2 2 2 0 010-3.5 2 2 0 002-1.5V7a2 2 0 00-2-2H5z" /></svg>
            </div>
          </div>
          <button onClick={onViewAll} className="border border-[#1976D2] textcolor px-4 py-2 rounded-md w-full flex items-center justify-center gap-2 hover:bg-gradient-to-r from-[#673AB7] to-[#1976D2] hover:text-white">
            <span>View All Codes</span>
            <MdArrowForwardIos size={20} />
          </button>
        </div>
      </div>

    </div>
  );
};

export default AssessmentCodeCard;